import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import "./search-input.component.scss";

function SearchInputComponent(props: any) {
  const history = useHistory();
  const [value, setValue] = useState("");

  useEffect(() => {
    if (window?.location?.search) {
      let arr = String(window?.location?.search).split("?");
      if (arr.length === 0) return;
      let str = arr[1].toLowerCase();
      if (str && str.indexOf("value=") !== -1) {
        arr = str.split("value=");
        str = arr[1];
        if (str) {
          arr = str.split("&");
          str = arr[0];
          if (str) {
            // found sale query param
            if (str) {
              setValue(decodeURI(str));
            }
          }
        }
      }
    }
  }, []);

  const onInputChange = (e: any) => {
    setValue(e.target?.value);
  };

  const handleKeyDown = (e: any) => {
    if (e.key === "Enter") {
      // Close mobile keyboard by removing focus from input
      e.target.blur();
      const searchValue = value?.trim();
      history.push(searchValue ? `/search?value=${encodeURIComponent(searchValue)}` : "/search");
    }
  };

  const handleSearchClick = (e: any) => {
    // Close mobile keyboard by removing focus from input
    const input = document.querySelector('.search-input .input') as HTMLInputElement;
    if (input) {
      input.blur();
    }

    if (window.innerWidth <= 767 && props.onMobileSearchClick) {
      e.preventDefault();
      props.onMobileSearchClick();
      return;
    }

    e.preventDefault();
    const searchValue = value?.trim();
    history.push(searchValue ? `/search?value=${encodeURIComponent(searchValue)}` : "/search");
  };

  return (
    <div className='search-input'>
      <input
        type='text'
        autoComplete='off'
        autoCapitalize="none"
        value={value}
        onChange={(e) => onInputChange(e)}
        onKeyDown={handleKeyDown}
        placeholder='Бүтээгдэхүүн хайх'
        className='input'
      />
      <a
        href={value ? `/search?value=${encodeURIComponent(value?.trim())}` : "/search"}
        className='icon icon-search cursor search-button'
        onClick={handleSearchClick}></a>
    </div>
  );
}

export default SearchInputComponent;
